/**
 * Profile field visibility from has_career_journey_created (backend).
 *
 * false → hide CJ-managed fields (preferred company/env, career extras, soft skills/languages)
 * true  → show all profile fields
 *
 * Complete Profile (when false): keep everything except preferred company + work environment
 * Career Details (when false): CV / LinkedIn only
 * Choose Roles (when false): preferred role + technical skills only
 */
export function getShowFullProfileFields(profile) {
  return false;
}
